import React, { useState } from 'react';
import { Modal, Form, Input, Button } from 'antd';

const CreateAudienceModal = ({ visible, onCancel, onCreate, loading }) => {
      const [form] = Form.useForm();
      const [charCount, setCharCount] = useState(0);

      const handleOk = () => {
            form.validateFields().then(values => {
                  onCreate(values.audienceName, values.description);
            }).catch(info => {
                  console.log('Validate Failed:', info);
            });
      };

      const handleValuesChange = (changedValues, allValues) => {
            if (changedValues.audienceName !== undefined) {
                  setCharCount(changedValues.audienceName.length);
            }
      };

      const afterClose = () => {
            form.resetFields();
            setCharCount(0);
      }

      return (
            <Modal
                  visible={visible}
                  title="Tạo tập khách hàng mới"
                  onCancel={onCancel}
                  afterClose={afterClose}
                  footer={[
                        <Button key="back" onClick={onCancel}>
                              Hủy
                        </Button>,
                        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                              Tạo
                        </Button>,
                  ]}
            >
                  <Form
                        form={form}
                        layout="vertical"
                        onValuesChange={handleValuesChange}
                  >
                        <Form.Item
                              name="audienceName"
                              label="Tên tập khách hàng"
                              rules={[
                                    { required: true, message: 'Vui lòng nhập tên tập khách hàng!' },
                                    { max: 100, message: 'Tên tập khách hàng không quá 100 ký tự!' }
                              ]}
                        >
                              <Input placeholder="Nhập tên tập..." maxLength={100} />
                        </Form.Item>
                        <div style={{ textAlign: 'right', color: charCount > 100 ? 'red' : 'inherit', marginTop: '-10px', marginBottom: '10px' }}>
                              {charCount}/100
                        </div>

                        <Form.Item
                              name="description"
                              label="Mô tả"
                              rules={[
                                    { required: true, message: 'Vui lòng nhập mô tả!' }
                              ]}
                        >
                              <Input.TextArea placeholder="Nhập mô tả..." rows={4} />
                        </Form.Item>
                  </Form>
            </Modal>
      );
};

export default CreateAudienceModal;
